import React from 'react';
import { i18n_style } from '@yi/i18n/phrases/i18n_style';

import { useLocale } from '../../LocaleProvider';
import { FiltersSelectWithAutocomplete } from '../FiltersSelectWithAutocomplete';

const FACET_NAME = 'ALGOLIA_style';

export const StyleSelect: React.FC<{ containerRef?: HTMLElement | null }> = ({ containerRef }) => {
  const { locale } = useLocale();

  return (
    <FiltersSelectWithAutocomplete
      attribute={FACET_NAME}
      containerRef={containerRef}
      label={i18n_style(locale)}
    />
  );
};
